// EN/FR translations for CUPE Local 4957
export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About",
      rights: "Your Rights",
      bargaining: "Bargaining",
      news: "News",
      events: "Events",
      executive: "Executive",
      gallery: "Gallery",
      memberCorner: "Member Corner",
      community: "Community",
      resources: "Resources",
      contact: "Contact",
      memberPortal: "Member Portal",
      login: "Login",
      register: "Register",
      admin: "Admin",
      logout: "Logout",
    },
    common: {
      learnMore: "Learn More",
      readMore: "Read more",
      viewAll: "View all",
      download: "Download",
      submit: "Submit",
      cancel: "Cancel",
      save: "Save",
      delete: "Delete",
      edit: "Edit",
      search: "Search",
      loading: "Loading…",
      backHome: "Back to Home",
      whyMatters: "Why this matters to you",
      all: "All",
      yes: "Yes",
      no: "No",
    },
    hero: {
      headline: "Standing Together. Protecting Workers. Building a Better Workplace.",
      subtext: "Representing the housekeepers, servers, front desk, and care staff with strength, fairness, and solidarity.",
      cta1: "Know Your Rights",
      cta2: "Contact a Steward",
      cta3: "Upcoming Meetings",
    },
    home: {
      quickActions: "Quick Actions",
      quickFile: "File a Grievance",
      quickAgreement: "Collective Agreement",
      quickExec: "Meet Your Executive",
      quickMemberCorner: "Member Corner",
      quickNews: "News & Updates",
      quickEvents: "Upcoming Events",
      leadershipTitle: "Leadership in Action",
      leadershipSub: "Live transparency: what your union is doing for you right now.",
      grievancesFiled: "Grievances filed",
      meetingsHeld: "Meetings held",
      safetyEscalations: "Safety escalations",
      winsAchieved: "Wins achieved",
      bargainingUpdates: "Bargaining updates",
      recentActions: "Recent leadership actions",
      wpTitle: "In Our Workplace",
      wpSub: "Bargaining tables, bedside care, training rooms, and the moments that bring us together.",
      wpBoard: "Bargaining at the table",
      wpCare: "Caring for our residents",
      wpSolidarity: "Solidarity in action",
      wpFrontline: "Frontline staff",
      wpElderly: "Compassionate elder care",
      wpTraining: "Steward training",
      bargainingTitle: "Where we are in bargaining",
      newsTitle: "Latest News",
      eventsTitle: "Upcoming Events",
      noEvents: "No upcoming events yet.",
      noNews: "No news yet.",
    },
    bargainingStages: {
      1: "Research",
      2: "Proposal Building",
      3: "Negotiation",
      4: "Tentative Agreement",
      5: "Ratification",
    },
    about: {
      title: "About CUPE Local 4957",
      whoTitle: "Who We Are",
      whoBody: "CUPE Local 4957 represents the employees of Oakpark Retirement Community in Ottawa. We advocate for better wages, fair working conditions, job security, pensions, benefits, and workplace respect - every member, every shift, every day.",
      missionTitle: "Our Mission",
      missionItems: [
        "Protect worker rights",
        "Negotiate fair agreements",
        "Eliminate discrimination",
        "Promote equality",
        "Improve social and economic wellbeing",
        "Strengthen labour unity",
      ],
      whyTitle: "Why Unions Matter",
      whyBargain: { title: "Collective Bargaining", body: "When we negotiate as one, we win wages, benefits, and protections no individual could secure alone." },
      whySolidarity: { title: "Solidarity", body: "Standing with each other is what turns 'I' into 'we' - and 'we' is how change happens." },
      whyDues: { title: "How Dues Work", body: "Dues fund legal representation, training, bargaining support, and the staff that defends every member." },
      whyGrievance: { title: "Grievances", body: "A grievance is your formal right to challenge unfair treatment - and we walk every member through the process." },
    },
    rights: {
      title: "Your Rights",
      agreementTitle: "Collective Agreement",
      agreementSub: "Your contract. Download, read, and bring it to every meeting.",
      grievanceTitle: "Grievance Process",
      grievanceSteps: [
        { t: "Identify the Issue", d: "Document what happened, when, and who was involved." },
        { t: "Speak to a Steward", d: "Your steward will help you assess and protect your rights." },
        { t: "Document the Issue", d: "Statements, schedules, emails - gather everything." },
        { t: "Submit the Grievance", d: "Filed within timelines in the collective agreement." },
        { t: "Investigation", d: "Union and employer meet to resolve at the lowest possible step." },
        { t: "Resolution or Arbitration", d: "Settlement, withdrawal, or independent arbitration." },
      ],
      workplaceTitle: "Workplace Rights",
      workplaceCards: [
        { t: "Scheduling", d: "Posted schedules, shift change rules, and minimum rest periods." },
        { t: "Overtime", d: "Premium pay, voluntary acceptance, and equitable distribution." },
        { t: "Health & Safety", d: "Right to refuse unsafe work. Joint Health & Safety Committee." },
        { t: "Vacation", d: "Earned entitlement, scheduling preferences, and carry-over rules." },
        { t: "Discipline", d: "Just cause, union representation, and progressive discipline." },
        { t: "Harassment", d: "Zero-tolerance protections and confidential reporting." },
      ],
      faqTitle: "Member FAQs",
      faqs: [
        { q: "Can I refuse unsafe work?", a: "Yes. Under the Occupational Health and Safety Act you have the right to refuse work you believe is unsafe. Contact your steward immediately." },
        { q: "What if management disciplines me?", a: "You have the right to union representation in any meeting that could lead to discipline. Ask for your steward before answering questions." },
        { q: "Who do I contact first?", a: "Your shop steward. See the Executive & Stewards page for contacts and office hours." },
        { q: "What are union dues used for?", a: "Bargaining, legal representation, training, grievance support, and our local's operating costs. Detailed reports are shared at general meetings." },
      ],
    },
    bargaining: {
      title: "Bargaining Hub",
      sub: "Live transparency on where your contract stands.",
      progressTitle: "Current Status",
      latestUpdate: "Latest Update",
      proposalsTitle: "Proposal Themes",
      proposalItems: [
        "Wage increases aligned with cost of living",
        "Pension improvements & retirement security",
        "Scheduling fairness & predictability",
        "Mental health & burnout supports",
      ],
      surveysTitle: "Member Surveys",
      surveysSub: "Surveys & ratification voting live in the Member Portal.",
      goPortal: "Open Member Portal",
    },
    news: {
      title: "News & Member Alerts",
      sub: "Workplace updates, sector news, and the issues that matter to you.",
      categories: ["all", "Bargaining", "Government Policy", "Labour News", "Sector News", "Cost of Living", "Employment Law", "CUPE National"],
    },
    events: {
      title: "Events & Meetings",
      sub: "Membership meetings, training, and community gatherings.",
      countdown: "Next meeting in",
      days: "days",
      hours: "hours",
      minutes: "minutes",
      rsvp: "RSVP",
      rsvpd: "You're going",
      rsvpLogin: "Log in to RSVP",
      noEvents: "No events scheduled yet.",
    },
    executive: {
      title: "Executive & Stewards",
      sub: "Your elected leadership and frontline stewards.",
      executives: "Executive Board",
      exco: "Executive Committee (EXCO)",
      stewards: "Stewards",
      stewardLabel: "Steward",
      officeHours: "Office hours",
      contactBtn: "Contact",
      contactPrompt: "Need to reach your executive or a steward? Email us directly.",
      workingOn: "What leadership is working on now",
    },
    gallery: {
      title: "Gallery",
      sub: "Moments of solidarity, care, and community at Oakpark.",
    },
    memberCorner: {
      badge: "Member Corner",
      title: "Member Corner",
      sub: "Your space to share ideas, celebrate wins, and lift each other up.",
      ideasTitle: "Share Your Ideas",
      ideasBody: "What would make our next year-end function, summer BBQ, or social event unforgettable? Tell us what you'd love to see.",
      ideaEx1: "Year-end holiday functions",
      ideaEx2: "Summer BBQ activities and games",
      ideaEx3: "Social gatherings and volunteer days",
      ideaEx4: "Member appreciation events",
      celebrateTitle: "Celebrate With Us",
      celebrateBody: "New babies, baby showers, marriages, retirements, graduations, or any milestone worth sharing with your sisters and brothers - we want to hear about it.",
      formTitle: "Share With Us",
      formSub: "Submit an idea or a celebration below. If it's a personal moment, tick the consent box so we can share it with our members.",
      name: "Your name",
      email: "Your email",
      categoryLabel: "What are you sharing?",
      message: "Your message",
      photo: "Photo",
      photoTooBig: "Photo must be under 2MB.",
      optional: "optional",
      consent: "I give consent for CUPE Local 4957 to share my celebration with fellow members on this website and in communications.",
      send: "Share With Us",
      thanks: "Thank you! Your submission has been sent.",
      cat: {
        idea: "Ideas for events",
        baby: "New baby",
        shower: "Baby shower",
        marriage: "Marriage",
        retirement: "Retirement",
        graduation: "Graduation",
        milestone: "Other milestone",
      },
    },
    community: {
      title: "Member Community",
      sub: "Birthdays, retirements, new hires, milestones, wins - and wellness.",
      board: "Community Board",
      spotlights: "Member Spotlights",
      wins: "Wins Wall",
      wellness: "Wellness Corner",
      wellnessItems: [
        { t: "Mental Health", d: "Telus Health EAP, CUPE Member Assistance Program." },
        { t: "Burnout Support", d: "Peer support network and confidential check-ins." },
        { t: "Financial Wellness", d: "Pension counselling, budgeting workshops." },
      ],
    },
    resources: {
      title: "Resources & Documents",
      sub: "Searchable library of bylaws, forms, and meeting minutes.",
      searchPlaceholder: "Search documents…",
      categories: ["all", "Bylaws", "Collective Agreement", "CUPE Constitution", "Grievance Forms", "Health & Safety", "Leave Forms", "Meeting Minutes"],
      noResults: "No documents match your search.",
    },
    contact: {
      title: "Contact Us",
      sub: "Reach out to your union - we're here for you.",
      emailLabel: "Email",
      officeLabel: "Office",
      officeValue: "c/o Oakpark Retirement Community, 2 Valor Dr, Ottawa",
      findUs: "Find Us",
      getDirections: "Get Directions",
      formTitle: "Send us a message",
      name: "Name",
      email: "Email",
      subject: "Subject",
      message: "Message",
      send: "Send Message",
      sent: "Message sent! We'll be in touch soon.",
      emergencyTitle: "Emergency Workplace Support",
      emergencySub: "For urgent safety or harassment issues, contact a steward immediately.",
      grievanceTitle: "File a Grievance",
      grievanceSub: "Quick submission - a steward will follow up within 48 hours.",
      issueType: "Issue type",
      description: "Description",
      submitGrievance: "Submit Grievance",
      grievanceSent: "Grievance submitted. A steward will be in touch.",
      anonymousTitle: "Anonymous Workplace Report",
      anonymousSub: "Report safety, harassment, or other issues without identifying yourself.",
      submitAnonymous: "Submit Anonymously",
      anonymousSent: "Report submitted anonymously. Thank you.",
    },
    auth: {
      loginTitle: "Member Login",
      registerTitle: "Member Registration",
      email: "Email",
      password: "Password",
      name: "Full Name",
      loginBtn: "Log In",
      registerBtn: "Create Account",
      noAccount: "Don't have an account?",
      haveAccount: "Already a member?",
      pendingMsg: "Your account is pending admin approval.",
      registrationSuccess: "Registration submitted. An admin will approve your account.",
    },
    portal: {
      title: "Member Portal",
      welcome: "Welcome",
      surveysTitle: "Active Surveys & Votes",
      noSurveys: "No active surveys right now.",
      voteBtn: "Submit Vote",
      voted: "You voted",
      results: "Results",
      pending: "Account Pending Approval",
      pendingMsg: "Your registration has been received. An admin will approve your account soon. You'll be notified once approved.",
    },
    admin: {
      title: "Admin Dashboard",
      members: "Members",
      news: "News",
      events: "Events",
      executive: "Executive",
      announcements: "Announcements",
      bargaining: "Bargaining",
      resources: "Resources",
      community: "Community",
      submissions: "Submissions",
      surveys: "Surveys",
      leadership: "Leadership Feed",
      pendingApprovals: "Pending Approvals",
      approve: "Approve",
      reject: "Reject",
      create: "Create",
      newPost: "New Post",
      newEvent: "New Event",
      newExec: "New Executive / Steward",
      newAnnouncement: "New Announcement",
      newResource: "New Resource",
      newCommunity: "New Community Post",
      newSurvey: "New Survey",
      newAction: "New Leadership Action",
      grievanceSubs: "Grievance Submissions",
      contactSubs: "Contact Submissions",
      anonReports: "Anonymous Reports",
      newsletterSubs: "Newsletter Subscribers",
      memberCornerSubs: "Member Corner Submissions",
    },
    footer: {
      tagline: "Standing Together. Protecting Workers.",
      contact: "Contact",
      quickLinks: "Quick Links",
      newsletter: "Newsletter",
      newsletterSub: "Get bargaining updates, meeting reminders, and alerts in your inbox.",
      newsletterPlaceholder: "Your email",
      newsletterSuccess: "You're subscribed. Welcome!",
      newsletterAlready: "You're already on the list.",
      sister: "Solidarity with CUPE Locals 1158 & 513",
      copyright: "Oakpark Retirement Community Employees",
    },
  },
  fr: {
    nav: {
      home: "Accueil",
      about: "À propos",
      rights: "Vos droits",
      bargaining: "Négociation",
      news: "Nouvelles",
      events: "Événements",
      executive: "Direction",
      gallery: "Galerie",
      memberCorner: "Coin des membres",
      community: "Communauté",
      resources: "Ressources",
      contact: "Contact",
      memberPortal: "Portail Membre",
      login: "Connexion",
      register: "Inscription",
      admin: "Admin",
      logout: "Déconnexion",
    },
    common: {
      learnMore: "En savoir plus",
      readMore: "Lire plus",
      viewAll: "Tout voir",
      download: "Télécharger",
      submit: "Soumettre",
      cancel: "Annuler",
      save: "Enregistrer",
      delete: "Supprimer",
      edit: "Modifier",
      search: "Rechercher",
      loading: "Chargement…",
      backHome: "Retour à l'accueil",
      whyMatters: "Pourquoi c'est important",
      all: "Tous",
      yes: "Oui",
      no: "Non",
    },
    hero: {
      headline: "Ensemble. Protéger les travailleurs. Bâtir un meilleur milieu de travail.",
      subtext: "Représenter les préposé·e·s à l'entretien, au service, à l'accueil et aux soins avec force, équité et solidarité.",
      cta1: "Connaître vos droits",
      cta2: "Contacter un·e délégué·e",
      cta3: "Prochaines réunions",
    },
    home: {
      quickActions: "Actions rapides",
      quickFile: "Déposer un grief",
      quickAgreement: "Convention collective",
      quickExec: "Votre direction",
      quickMemberCorner: "Coin des membres",
      quickNews: "Nouvelles et mises à jour",
      quickEvents: "Événements à venir",
      leadershipTitle: "Leadership en action",
      leadershipSub: "Transparence en direct: ce que votre syndicat fait pour vous, maintenant.",
      grievancesFiled: "Griefs déposés",
      meetingsHeld: "Réunions tenues",
      safetyEscalations: "Signalements de sécurité",
      winsAchieved: "Victoires obtenues",
      bargainingUpdates: "Mises à jour des négociations",
      recentActions: "Actions récentes du leadership",
      wpTitle: "Dans notre milieu de travail",
      wpSub: "Table de négociation, soins au chevet, formations et moments qui nous rassemblent.",
      wpBoard: "À la table de négociation",
      wpCare: "Soigner nos résidents",
      wpSolidarity: "Solidarité en action",
      wpFrontline: "Personnel de première ligne",
      wpElderly: "Soins compatissants aux aînés",
      wpTraining: "Formation des délégués",
      bargainingTitle: "État des négociations",
      newsTitle: "Dernières nouvelles",
      eventsTitle: "Événements à venir",
      noEvents: "Aucun événement à venir.",
      noNews: "Aucune nouvelle pour l'instant.",
    },
    bargainingStages: {
      1: "Recherche",
      2: "Préparation des propositions",
      3: "Négociation",
      4: "Entente de principe",
      5: "Ratification",
    },
    about: {
      title: "À propos du SCFP 4957",
      whoTitle: "Qui nous sommes",
      whoBody: "La section locale 4957 du SCFP représente les employés d'Oakpark Retirement Community à Ottawa. Nous défendons de meilleurs salaires, des conditions de travail équitables, la sécurité d'emploi, les pensions, les avantages sociaux et le respect au travail - chaque membre, chaque quart, chaque jour.",
      missionTitle: "Notre mission",
      missionItems: [
        "Protéger les droits des travailleurs",
        "Négocier des conventions équitables",
        "Éliminer la discrimination",
        "Promouvoir l'égalité",
        "Améliorer le bien-être social et économique",
        "Renforcer l'unité syndicale",
      ],
      whyTitle: "Pourquoi les syndicats sont essentiels",
      whyBargain: { title: "Négociation collective", body: "Quand nous négocions ensemble, nous obtenons des salaires, avantages et protections qu'aucune personne seule ne pourrait obtenir." },
      whySolidarity: { title: "Solidarité", body: "S'unir transforme « je » en « nous » - et c'est ainsi que le changement se produit." },
      whyDues: { title: "Comment fonctionnent les cotisations", body: "Les cotisations financent la représentation juridique, la formation, le soutien à la négociation et le personnel qui défend chaque membre." },
      whyGrievance: { title: "Les griefs", body: "Un grief est votre droit formel de contester un traitement injuste - et nous accompagnons chaque membre dans le processus." },
    },
    rights: {
      title: "Vos droits",
      agreementTitle: "Convention collective",
      agreementSub: "Votre contrat. Téléchargez-le, lisez-le, apportez-le à chaque réunion.",
      grievanceTitle: "Processus de grief",
      grievanceSteps: [
        { t: "Identifier le problème", d: "Documentez ce qui s'est passé, quand, et qui était impliqué." },
        { t: "Parler à un·e délégué·e", d: "Votre délégué·e vous aidera à évaluer et protéger vos droits." },
        { t: "Documenter", d: "Déclarations, horaires, courriels - rassemblez tout." },
        { t: "Soumettre le grief", d: "Déposé dans les délais de la convention collective." },
        { t: "Enquête", d: "Le syndicat et l'employeur tentent de résoudre au plus bas niveau." },
        { t: "Résolution ou arbitrage", d: "Règlement, retrait ou arbitrage indépendant." },
      ],
      workplaceTitle: "Droits au travail",
      workplaceCards: [
        { t: "Horaires", d: "Affichage, règles de changement de quart et périodes de repos minimales." },
        { t: "Heures supplémentaires", d: "Prime, acceptation volontaire et répartition équitable." },
        { t: "Santé & sécurité", d: "Droit de refuser un travail dangereux. Comité mixte SST." },
        { t: "Vacances", d: "Droits acquis, préférences d'horaire et règles de report." },
        { t: "Discipline", d: "Juste cause, représentation syndicale, discipline progressive." },
        { t: "Harcèlement", d: "Protections de tolérance zéro et signalement confidentiel." },
      ],
      faqTitle: "FAQ des membres",
      faqs: [
        { q: "Puis-je refuser un travail dangereux?", a: "Oui. La Loi sur la santé et la sécurité au travail vous donne ce droit. Contactez immédiatement votre délégué·e." },
        { q: "Que faire si la direction me discipline?", a: "Vous avez droit à la représentation syndicale lors de toute réunion pouvant mener à de la discipline. Demandez votre délégué·e avant de répondre." },
        { q: "Qui dois-je contacter en premier?", a: "Votre délégué·e syndical·e. Voir la page Direction & délégués pour les coordonnées." },
        { q: "À quoi servent les cotisations syndicales?", a: "Négociation, représentation juridique, formation, soutien aux griefs et fonctionnement de la section. Rapports détaillés présentés aux assemblées." },
      ],
    },
    bargaining: {
      title: "Centre de négociation",
      sub: "Transparence en direct sur l'état de votre contrat.",
      progressTitle: "Étape actuelle",
      latestUpdate: "Dernière mise à jour",
      proposalsTitle: "Thèmes des propositions",
      proposalItems: [
        "Augmentations salariales alignées sur le coût de la vie",
        "Améliorations du régime de retraite",
        "Équité et prévisibilité des horaires",
        "Soutien en santé mentale et épuisement",
      ],
      surveysTitle: "Sondages des membres",
      surveysSub: "Sondages et votes de ratification en direct dans le portail membre.",
      goPortal: "Ouvrir le portail membre",
    },
    news: {
      title: "Nouvelles et alertes",
      sub: "Mises à jour du milieu de travail, nouvelles du secteur et enjeux qui vous touchent.",
      categories: ["all", "Bargaining", "Government Policy", "Labour News", "Sector News", "Cost of Living", "Employment Law", "CUPE National"],
    },
    events: {
      title: "Événements et réunions",
      sub: "Assemblées, formations et rassemblements communautaires.",
      countdown: "Prochaine réunion dans",
      days: "jours",
      hours: "heures",
      minutes: "minutes",
      rsvp: "Confirmer",
      rsvpd: "Vous y serez",
      rsvpLogin: "Connectez-vous pour confirmer",
      noEvents: "Aucun événement prévu pour l'instant.",
    },
    executive: {
      title: "Direction et délégués",
      sub: "Votre leadership élu et vos délégué·e·s de première ligne.",
      executives: "Conseil exécutif",
      exco: "Comité exécutif (EXCO)",
      stewards: "Délégués",
      stewardLabel: "Délégué·e",
      officeHours: "Heures de bureau",
      contactBtn: "Contacter",
      contactPrompt: "Besoin de joindre votre direction ou un·e délégué·e? Écrivez-nous directement.",
      workingOn: "Sur quoi le leadership travaille actuellement",
    },
    gallery: {
      title: "Galerie",
      sub: "Moments de solidarité, de soin et de communauté à Oakpark.",
    },
    memberCorner: {
      badge: "Coin des membres",
      title: "Coin des membres",
      sub: "Votre espace pour partager des idées, célébrer les victoires et se soutenir.",
      ideasTitle: "Partagez vos idées",
      ideasBody: "Qu'est-ce qui rendrait inoubliables nos fêtes de fin d'année, BBQ d'été ou événements sociaux? Dites-nous.",
      ideaEx1: "Fêtes de fin d'année",
      ideaEx2: "Activités et jeux du BBQ d'été",
      ideaEx3: "Rassemblements sociaux et journées de bénévolat",
      ideaEx4: "Événements d'appréciation des membres",
      celebrateTitle: "Célébrez avec nous",
      celebrateBody: "Nouveaux bébés, baby showers, mariages, départs à la retraite, diplômes ou tout jalon à partager - nous voulons le célébrer avec vous.",
      formTitle: "Partagez avec nous",
      formSub: "Soumettez une idée ou une célébration. Pour un moment personnel, cochez le consentement pour que nous puissions le partager.",
      name: "Votre nom",
      email: "Votre courriel",
      categoryLabel: "Que partagez-vous?",
      message: "Votre message",
      photo: "Photo",
      photoTooBig: "La photo doit faire moins de 2 Mo.",
      optional: "facultatif",
      consent: "Je donne mon consentement pour que la section locale 4957 du SCFP partage ma célébration avec les membres sur ce site et dans ses communications.",
      send: "Partager",
      thanks: "Merci! Votre soumission a été envoyée.",
      cat: {
        idea: "Idées d'événements",
        baby: "Nouveau bébé",
        shower: "Baby shower",
        marriage: "Mariage",
        retirement: "Retraite",
        graduation: "Diplôme",
        milestone: "Autre jalon",
      },
    },
    community: {
      title: "Communauté des membres",
      sub: "Anniversaires, départs à la retraite, nouvelles embauches, jalons, victoires - et mieux-être.",
      board: "Tableau communautaire",
      spotlights: "Membres en vedette",
      wins: "Mur des victoires",
      wellness: "Coin mieux-être",
      wellnessItems: [
        { t: "Santé mentale", d: "PAE Telus Santé, Programme d'aide aux membres du SCFP." },
        { t: "Soutien à l'épuisement", d: "Réseau de soutien par les pairs et accompagnement confidentiel." },
        { t: "Mieux-être financier", d: "Conseils de retraite, ateliers de budgétisation." },
      ],
    },
    resources: {
      title: "Ressources et documents",
      sub: "Bibliothèque consultable de statuts, formulaires et procès-verbaux.",
      searchPlaceholder: "Rechercher des documents…",
      categories: ["all", "Bylaws", "Collective Agreement", "CUPE Constitution", "Grievance Forms", "Health & Safety", "Leave Forms", "Meeting Minutes"],
      noResults: "Aucun document ne correspond à votre recherche.",
    },
    contact: {
      title: "Nous joindre",
      sub: "Communiquez avec votre syndicat - nous sommes là pour vous.",
      emailLabel: "Courriel",
      officeLabel: "Bureau",
      officeValue: "a/s Oakpark Retirement Community, 2 Valor Dr, Ottawa",
      findUs: "Nous trouver",
      getDirections: "Obtenir l'itinéraire",
      formTitle: "Envoyez-nous un message",
      name: "Nom",
      email: "Courriel",
      subject: "Objet",
      message: "Message",
      send: "Envoyer",
      sent: "Message envoyé! Nous vous répondrons sous peu.",
      emergencyTitle: "Soutien d'urgence au travail",
      emergencySub: "Pour les urgences (sécurité, harcèlement), contactez un·e délégué·e immédiatement.",
      grievanceTitle: "Déposer un grief",
      grievanceSub: "Soumission rapide - un·e délégué·e fera le suivi dans 48 heures.",
      issueType: "Type d'enjeu",
      description: "Description",
      submitGrievance: "Soumettre le grief",
      grievanceSent: "Grief soumis. Un·e délégué·e vous contactera.",
      anonymousTitle: "Signalement anonyme",
      anonymousSub: "Signalez sécurité, harcèlement ou autre sans vous identifier.",
      submitAnonymous: "Soumettre anonymement",
      anonymousSent: "Signalement soumis anonymement. Merci.",
    },
    auth: {
      loginTitle: "Connexion membre",
      registerTitle: "Inscription membre",
      email: "Courriel",
      password: "Mot de passe",
      name: "Nom complet",
      loginBtn: "Se connecter",
      registerBtn: "Créer un compte",
      noAccount: "Pas de compte?",
      haveAccount: "Déjà membre?",
      pendingMsg: "Votre compte est en attente d'approbation.",
      registrationSuccess: "Inscription soumise. Un administrateur approuvera votre compte.",
    },
    portal: {
      title: "Portail membre",
      welcome: "Bienvenue",
      surveysTitle: "Sondages et votes actifs",
      noSurveys: "Aucun sondage actif pour le moment.",
      voteBtn: "Soumettre le vote",
      voted: "Vous avez voté",
      results: "Résultats",
      pending: "Compte en attente",
      pendingMsg: "Votre inscription a été reçue. Un administrateur approuvera votre compte bientôt.",
    },
    admin: {
      title: "Tableau admin",
      members: "Membres",
      news: "Nouvelles",
      events: "Événements",
      executive: "Direction",
      announcements: "Annonces",
      bargaining: "Négociation",
      resources: "Ressources",
      community: "Communauté",
      submissions: "Soumissions",
      surveys: "Sondages",
      leadership: "Flux Leadership",
      pendingApprovals: "Approbations en attente",
      approve: "Approuver",
      reject: "Rejeter",
      create: "Créer",
      newPost: "Nouvelle publication",
      newEvent: "Nouvel événement",
      newExec: "Nouveau membre direction / délégué",
      newAnnouncement: "Nouvelle annonce",
      newResource: "Nouvelle ressource",
      newCommunity: "Nouvelle publication communauté",
      newSurvey: "Nouveau sondage",
      newAction: "Nouvelle action leadership",
      grievanceSubs: "Soumissions de griefs",
      contactSubs: "Soumissions de contact",
      anonReports: "Signalements anonymes",
      newsletterSubs: "Abonné·e·s infolettre",
      memberCornerSubs: "Coin des membres",
    },
    footer: {
      tagline: "Ensemble. Protéger les travailleurs.",
      contact: "Contact",
      quickLinks: "Liens rapides",
      newsletter: "Infolettre",
      newsletterSub: "Mises à jour des négociations, rappels de réunions et alertes par courriel.",
      newsletterPlaceholder: "Votre courriel",
      newsletterSuccess: "Vous êtes inscrit·e. Bienvenue!",
      newsletterAlready: "Vous êtes déjà sur la liste.",
      sister: "Solidarité avec les sections SCFP 1158 et 513",
      copyright: "Employé·e·s d'Oakpark Retirement Community",
    },
  },
};
